import styled, { CSSObject } from "styled-components";

export const CloseIconContainer = styled.div<{ isFtuBottomsheet?: boolean; styles?: CSSObject }>(
    ({ isFtuBottomsheet = false, styles, theme }) => {
        const commonStyles = {
            borderRadius: "50%",
            cursor: "pointer",
            zIndex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            opacity: 0.5,
            backgroundColor: theme.colors[theme.colorMode].background_Overlay_Light,
            filter: "invert(100%)",
            position: "absolute" as CSSObject["position"],
        };
        if (isFtuBottomsheet) {
            return {
                ...commonStyles,
                width: theme.spacing.xLarge,
                height: theme.spacing.xLarge,
                top: "-185px",
                right: theme.spacing.large,
            };
        }
        return {
            ...commonStyles,
            width: theme.spacing.large,
            height: theme.spacing.large,
            top: theme.spacing.small,
            right: theme.spacing.small,
            ...styles,
        };
    },
);
